import { Image, Menu } from "antd";
import React, { Component } from "react";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import config from "../config";

class TicketMenu extends Component {
    constructor(props, context) {
        super(props);
        this.state = {
            items: [],
            remaining: [],
        };
    }
    handleMenuClick = (items) => {
        this.props.navigate("/" + items);
        this.props.closeMenu();
    };

    async componentDidMount() {
        const items = [
            {
                key: "info",
                type: "group",
                label: (
                    <div
                        style={{
                            padding: "15px",
                            color: "#fff",
                            backgroundColor: "#002766",
                        }}
                    >
                        <span className="menu-items-title" style={{ gap: 10 }}>
                            <img
                                src={require("../assets/images/NewDesign/TicketMenu.png")}
                                alt="Masters"
                                style={{ width: "22px" }}
                            />
                            {this.context.translate("_TICKET_LIST_")}
                        </span>

                        <p
                            style={{
                                fontSize: "10px",
                                marginTop: "5px",
                                color: "rgba(255, 255, 255, 0.8)",
                                marginBottom: "0px",
                            }}
                        >
                            {Number(config.showMenuDescription) !== 0 &&
                                this.context.translate("_TICKET_DESC_")}
                        </p>
                    </div>
                ),
            },
        ];

        const remaining2 = [
            {
                key: "ticketlist",
                type: "ticketlist",
                label: (
                    <div onClick={() => this.handleMenuClick("ticketlist")}>
                        <span className="submenu-items-title" style={{ gap: 10 }}>
                            <Image
                                src={require("../assets/images/NewDesign/ticket-icon.png")}
                                // alt="Masters"
                                style={{ width: "14px" }}
                            />
                            {this.context.translate("_TICKET_LIST_")}
                        </span>

                        <p
                            className="submenu-items-desc"
                        >
                            {Number(config.showMenuDescription) !== 0 &&
                                this.context.translate("_TICKET_DESC_")}
                        </p>
                    </div>
                ),
                children: [],
            },
        ];

        var remaining = [];
        for (var i = 0; i < remaining2.length; i++) {
            if (this.props.ticketManagement.includes(remaining2[i].key)) {
                remaining.push(remaining2[i]);
            }
        }
        // console.log(remaining)
        this.setState({ items: items, remaining: remaining });
    }
    render() {
        return (
            <div
                className="menu-items-card"
                style={{
                    width: Number(config.showMenuDescription) == 0 ? "300px" : "400px",
                }}
            >
                <div className="menu-items-list">
                    <Menu
                        style={{
                            // height: "90vh",
                            border: "none",
                            scrollbarWidth: "none",
                            overflow: "scroll",
                            // boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
                        }}
                        items={this.state.items}
                    />
                </div>
                <div
                    className="submenu-items-list"
                >
                    <Menu
                        className="tracking-list-menu"
                        style={{
                            height: "90vh",
                            border: "none",
                            scrollbarWidth: "none",
                            overflow: "scroll",
                            boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            alignContent: "flex-start",
                            height: "100%",
                        }}
                        mode="inline"
                        items={this.state.remaining}
                        onMouseLeave={() => this.props.closeMenu()}
                    />
                </div>
            </div>
        );
    }
}
TicketMenu.contextType = StoreContext;
export default observer(withRouter(TicketMenu));
